import { Component, inject, OnChanges, ChangeDetectionStrategy, input } from '@angular/core';
import { GuruEntity } from '../../../model/guru-entity';
import { UnitRatingResponse } from '../../../model/unit-rating-response';
import { UserStateService, ConfigurationSection } from '../../../services/user-state.service';
import { SelectionUtils } from '../../selection-utils';
import { UnitConversionUtils } from '../../unit-conversion-utils';
import { MatIcon } from '@angular/material/icon';
import { PerformanceResultsComponent } from '../../common/performance-results/performance-results.component';

@Component({
  selector: 'app-air-handler-unit-performance-output',
  imports: [MatIcon, PerformanceResultsComponent],
  templateUrl: './air-handler-unit-performance-output.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './air-handler-unit-performance-output.component.css',
})
export class AirHandlerUnitPerformanceOutputComponent implements OnChanges {
  private userStateService = inject(UserStateService);
  readonly ratingResponse = input.required<UnitRatingResponse>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  airflow = 0;
  standardAirflow = 0;
  isExpanded = true;
  isMetric = false;
  private sectionKey = ConfigurationSection.PERFORMANCE_RESULTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.clearOutputValues();
    const metricInput = SelectionUtils.getEntity(this.selectionEntities(), 'USMetricInput');
    this.isMetric = metricInput && 'true' === metricInput.Value;
    if (this.ratingResponse()) {
      this.airflow = this.ratingResponse().Airflow;
      this.standardAirflow = this.ratingResponse().StandardAirflow ?? 0;
    }
  }

  private clearOutputValues(): void {
    this.airflow = 0;
    this.standardAirflow = 0;
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  getAirflowMeasurementUnits(isStandard: boolean): string {
    return UnitConversionUtils.getAirflowUnits(this.isMetric, isStandard);
  }
}
